import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  Image,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";
import ModalPurchase from "../../components/ModalPurchase";
import { FormattedMessage, useIntl } from "react-intl";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import HeaderTabs from "../../components/HeaderTabs";
import { If, Then, Else } from "react-if";
import GoBackButton from "../../components/GoBackButton";

import styles from "./styles";

const CreditCardPayment = ({ navigation }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isFocused = useIsFocused();

  useEffect(() => {
    getDataCards();
  }, [isFocused]);

  async function getDataCards() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get("/cards", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const fetchedCards = res.data.data.map((item) => ({
          id: item.id,
          name: item.name,
          number: item.card_number,
          validity: item.expiration_date,
        }));

        setCards(fetchedCards);
        setIsLoading(false);
      })
      .catch(() => {
        const intl = useIntl();
        toast(
          intl.formatMessage({ id: "creditCardPayment.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  const renderCreditCard = ({ item }) => (
    <View style={styles.contentCard}>
      <TouchableOpacity
        style={styles.contentEdit}
        onPress={() => navigation.navigate("EditCard", { item })}
      >
        <FontAwesome name="edit" size={24} color="#077A97" />
      </TouchableOpacity>

      <Text style={styles.lbl}>
        <FormattedMessage id="newCard.placeholderNumCartao" />
      </Text>
      <Text style={styles.textDescription}>{item.number}</Text>
      <Text style={styles.lbl}>
        <FormattedMessage id="newCard.placeholderNomeCompleto" />
      </Text>
      <Text style={styles.textDescription}>{item.name}</Text>
      <Text style={styles.lbl}>
        <FormattedMessage id="newCard.placeholderValidade" />
      </Text>
      <Text style={styles.textDescription}>{item.validity}</Text>

      <TouchableOpacity
        style={{ padding: 10,
          width: 160,
          height: 28,
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "center",
          borderRadius: 4,
          backgroundColor: "#077A97",
          position: "relative",}}
        onPress={() => setModalVisible(!modalVisible)}
      >
        <Text style={styles.selectedCard}>
          <FormattedMessage id="creditCardPayment.btnUsarEste" />
        </Text>
      </TouchableOpacity>

      <Image
        source={require("../../../assets/masterCard.png")}
        style={styles.imgBank}
      />
    </View>
  );

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="creditCardPayment.headerCartaoCredito" />}
        subtitle={
          <FormattedMessage id="creditCardPayment.headerSubUtilizeCartao" />
        }
      />

      <If condition={isLoading}>
        <Then>
          <ActivityIndicator
            color="#2797A2"
            size="large"
            style={{ marginTop: 10 }}
          />
        </Then>
        <Else>
          <If condition={cards.length === 0}>
            <Then>
              <Text style={styles.textNotFoundAccounts}>
                <FormattedMessage id="creditCardPayment.txtNenhumCartaoEncontrado" />
              </Text>
            </Then>
            <Else>
              <FlatList
                data={cards}
                renderItem={renderCreditCard}
                keyExtractor={(item) => item.id.toString()}
                numColumns={2}
                columnWrapperStyle={{
                  justifyContent: "space-evenly",
                  width: "50%",
                  alignSelf: "center",
                  flexWrap: "wrap",
                  flex: 1,
                }}
                contentContainerStyle={{ paddingBottom: 20 }}
              />
            </Else>
          </If>
        </Else>
      </If>

      <View style={styles.container}>
        <TouchableOpacity
          style={styles.btnAdd}
          onPress={() => navigation.navigate("NewCard")}
        >
          <Text style={styles.textBtn}>
            <FormattedMessage id="creditCardPayment.btnUsarOutro" />
          </Text>
        </TouchableOpacity>

        <GoBackButton style={{ marginTop: 12, height: 48 }} />
      </View>

      {/* Modal for purchase confirmation */}
      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => navigation.navigate("Home")}
      >
        <ModalPurchase
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate("Home");
          }}
        />
      </Modal>
    </>
  );
};

export default CreditCardPayment;
